import Axios from "axios";
import {
    SET_PUR_REQ_MERGE_REPORT,
    UNSET_PUR_REQ_MERGE_REPORT,
  } from "@/store/mutation-types";
import {getPurReqMergeReport} from "@/store/api";

const state = {
    getPurReqMergeReport: [],
};

const getters = {
    getPurReqMergeReport(state) {
        return state.getPurReqMergeReport;
    },
};

const mutations = {
    [SET_PUR_REQ_MERGE_REPORT](state, data) {
        state.getPurReqMergeReport = data;
    },
    [UNSET_PUR_REQ_MERGE_REPORT](state) {
        state.getPurReqMergeReport = [];
    },
};

const actions = {
    getPurReqMergeReport({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.get(`${getPurReqMergeReport}`, { params: data })
                .then((response) => {
                    commit(SET_PUR_REQ_MERGE_REPORT, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_REQ_MERGE_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

